import React, { useEffect, useState } from "react";
import { getFiles, archiveFiles, deleteFiles } from "../api";
import Table from "../reusable_components/Table.jsx";
import HeaderSection from "../child_components/HeaderSection";
import Pagination from "../reusable_components/Pagination";
import { toast } from "react-toastify";
import moment from "moment";
import { btnCancel, btnOne } from "../utils/style.js";
import ConfirmationModal from "../reusable_components/ConfirmationModal.js";
import { setLoader } from "../reusable_components/Loader.js";

const DirectoryArchiveFiles = () => {
  const [files, setFiles] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedRows, setSelectedRows] = useState([]);
  const [showModal, setShowModal] = useState()
  const [filterQuery, setFilterQuery] = useState("");
  const [filterData, setFilterData] = useState({});
  const [reloadTable, setReloadTable] = useState(false)

  const handleRowSelect = (rowIndex) => {
    const updatedFiles = [...files];
    const rowId = updatedFiles[rowIndex].id;

    updatedFiles[rowIndex].selected = !updatedFiles[rowIndex].selected;

    setSelectedRows((prevSelectedRows) => {
      if (updatedFiles[rowIndex].selected) {
        return [...prevSelectedRows, rowId];
      } else {
        return prevSelectedRows.filter((id) => id !== rowId);
      }
    });

    setFiles(updatedFiles);
  };

  const fetchFiles = async (page = 1, filterQuery) => {
    setLoader(true);


    try {
      const archivedStatus = true;
      const response = await getFiles(page, archivedStatus, filterQuery);
      response?.data?.data?.forEach((record) => {
        const age = moment().diff(moment(record.publication_date), "months");
        record.age =
          age > 24
            ? "> 2 years"
            : age > 12
              ? "> 1 year"
              : age > 6
                ? "> 6 months"
                : "> 1 month";
        record.publication_date = moment(record.publication_date).format(
          "MM-DD-YYYY"
        );
        record.createdAt = moment(record.createdAt).format("MM-DD-YYYY");
      });

      setFiles(response.data?.data || []);
      setTotalPages(response.data?.pagination?.totalPages || 1);
    } catch (err) {
      toast.error("Error loading data")
    } finally {
      setLoader(false);
    }
  };

  const handleArchive = async () => {
    try {
      const data = { ids: selectedRows, archivedStatus: false };
      const result = await archiveFiles(data);
      if (result.status === 200) {
        setSelectedRows([]);
        // update the file to remove higlited row
        toast.success(`${result.data.message} File Unarchive`, { autoClose: 3000 });
        setReloadTable(true)
      } else {
        return toast.error(result.data.message, { autoClose: 3000 });
      }
    } catch (err) {
      toast.error("Failed to Unarchive", { autoClose: 3000 });
    }
  };

  const handleDelete = async () => {
    setLoader(true);
    try {
      const data = { ids: selectedRows };
      const result = await deleteFiles(data);
      if (result.status === 200) {
        setSelectedRows([]);
        toast.success(`${result.data.message} Files Deleted`, { autoClose: 3000 });
        setReloadTable(true)
      } else {
        return toast.error(result.data.message, { autoClose: 3000 });
      }
    } catch (err) {
      toast.error("Failed to delete");
    } finally {
      setShowModal(false)
      setLoader(true);
    }
  };

  useEffect(() => {
    fetchFiles(currentPage, filterQuery);
    setSelectedRows([]);
    setFiles((prevFiles) =>
      prevFiles.map((file) => ({ ...file, selected: false }))
    );
  }, [currentPage, filterQuery, reloadTable]);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const columns = [
    { header: "File", key: "file_name", width: "20%", isFilterEnable: true },
    { header: "Make", key: "manufacturer", width: "15%", isFilterEnable: true },
    { header: "Model", key: "model", width: "15%", isFilterEnable: true },
    { header: "Year", key: "year", width: "10%", isFilterEnable: true },
    { header: "Published At", key: "publication_date", width: "15%" },
    { header: "Uploaded At", key: "createdAt", width: "15%" },
    { header: "Age", key: "age", width: "10%" },
    // { header: "Uploaded By", key: "uploaded_by", width: "10%" },
  ];


  return (
    <>
      {
        showModal && <ConfirmationModal title={'PDF'} setShowForm={setShowModal} confirm={handleDelete} />
      }
      <div className="flex justify-between items-center mb-3">
        <HeaderSection title={"Archived Files"} />
        <div className="ml-auto flex space-x-2">
          <button
            disabled={selectedRows.length < 1}
            className={`px-3 py-1 text-sm rounded-md 
        ${selectedRows.length < 1
                ? `${btnOne} bg-red-500 border-customOne text-white cursor-not-allowed opacity-50`
                : `${btnOne} bg-red-500 border-customOne text-white hover:scale-110 transform transition-all duration-200`
              }`}
            onClick={() => setShowModal(true)}
          >
            Delete
          </button>
          <button
            disabled={selectedRows.length < 1}
            className={`px-3 py-1 text-sm rounded-md 
        ${selectedRows.length < 1
                ? `${btnCancel} text-white cursor-not-allowed opacity-80`
                : `${btnCancel} text-white hover:scale-110 transform transition-all duration-200`
              }`}
            onClick={handleArchive}
          >
            Unarchive
          </button>
        </div>
      </div>

      <Table data={files} columns={columns} onRowSelect={handleRowSelect} setFilterQuery={setFilterQuery} filterData={filterData} setFilterData={setFilterData} />
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
    </>
  );
};

export default DirectoryArchiveFiles;
